import { theme } from 'global';
import frame from 'public/mfa/Frame 3466494.svg';
import lockAndKeyImage from 'public/mfa/Lock_and_Key.svg';
import warning from 'public/mfa/Warning.svg';

export const { 50: AdminUserModeColor } = theme.colors.neutral;

export const AdminUserModeLogo: string = lockAndKeyImage;

export const AdminUserModeTitle: string =
  'Boost your security with 2-step verification';

export const AdminUserModeSubtitle: string =
  'Keep your business safe from fraud. Users will be verified using a code sent via mobile or email when signing in.';

/**********************************************************
Warning: DO NOT change the ordering of the following arrays, 
as they are linked to dialog rendering logic
***********************************************************/

export const RegularUserSkipLimit: number = 3;

export const RegularUserModeColors: string[] = [
  theme.colors.neutral[50],
  theme.colors.neutral[50],
  theme.colors.dangerLight,
];

export const RegularUserModeLogos: string[] = [lockAndKeyImage, frame, warning];

export const RegularUserModeTitles: string[] = [
  'Set up 2-step verification in 1 min',
  "Don't forget to set up 2-step verification",
  'Final reminder: set up 2-step verification',
];

export const RegularUserModeSubtitles: string[] = [
  'Your organisation is enhancing security and enabled 2-step verification for your account.',
  '2-step verification adds an extra layer of security, keeping your information safe. It only takes a minute.',
  'Protect your account now to avoid any interruptions next time you sign in. It only takes a minute.',
];
